// Note: The first file of a module here, must also register the module

import "./integration-errors.component";
import "./integration-field-mapping.component";
import "./integration-list.component";
import "./integration-login.component";
import "./integration-status-mapping.component";
import "./integration-uninstall.component";
import "./integration.controller";
